// Setup › Seats at `/c/{slug}/setup/seats` (design spec §9; core, managers). The open seat's
// drawer is in the URL (`?seat=`), next to the focus keys, so a reload or a shared link opens it.
import { createRoute, useNavigate } from "@tanstack/react-router";
import { SeatsScreen } from "../features/structure/seats-screen";
import { useCompany } from "../features/use-feature";
import { validateFocusSearch } from "../focus/focus";
import { setupRoute } from "./c.$slug.setup";

const ID = /^[0-9a-f-]{36}$/i;

export const setupSeatsRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "seats",
  validateSearch: (search: Record<string, unknown>) => ({
    ...validateFocusSearch(search),
    ...(typeof search.seat === "string" && ID.test(search.seat) ? { seat: search.seat } : {}),
    // SEARCH-NOTIF: ⌘K's "New seat".
    ...(search.new === "1" || search.new === 1 ? { new: "1" as const } : {}),
  }),
  component: function Seats() {
    const { api } = setupSeatsRoute.useRouteContext();
    const { seat, new: create } = setupSeatsRoute.useSearch();
    const navigate = useNavigate();
    return (
      <SeatsScreen
        api={api}
        company={useCompany()}
        seatId={seat}
        create={create === "1"}
        onSeat={(id) =>
          void navigate({
            to: ".",
            search: (prev: Record<string, unknown>) => {
              const { seat: _drop, ...rest } = prev;
              return id ? { ...rest, seat: id } : rest;
            },
          } as never)
        }
      />
    );
  },
});
